import Vue from 'vue'
import Router from 'vue-router'
// 路由文件
const servicePlan = () =>
	import('@/views/service-plan')
const businessGrade = () =>
	import('@/views/business-grade')
const InformationRegister = () =>
	import('@/views/information-register')
const confirm = () =>
	import('@/views/confirm')
const Result = () =>
	import('@/views/result')
const Search = () =>
	import('@/views/search')
const Blank = () =>
	import('@/views/blank')
const umallServicePlan = () =>
	import('@/views/umallCode/service-plan')
const umallBusinessGrade = () =>
	import('@/views/umallCode/business-grade')
const UmallInformationRegister = () =>
	import('@/views/umallCode/information-register')
const UmallConfirm = () =>
  import('@/views/umallCode/confirm')
  // umall 宽频1+N
const UmallBroadbandInformationRegister = () =>
	import('@/views/umallCode/information-broadband')
const UmallBroadbandConfirm = () =>
  import('@/views/umallCode/confirm/broadband.vue')
const UmallBroadbandResult = () =>
  import('@/views/umallCode/result/broadband.vue')
  
const UmallResult = () =>
	import('@/views/umallCode/result')
const NewQrCodePay = () =>
	import('@/views/umallCode/qrcode-pay/qrcode-pay')
const OldQrCodePay = () =>
	import('@/views/umallCode/qrcode-pay/oldqrcode-pay')
const OldQrCodePaying = () =>
	import('@/views/umallCode/qrcode-pay/paying')
		//5G登記頁面
const Register = () =>
	import('@/views/register/Register')
const RegisterSuccess = () =>
	import('@/views/register/registerSuccess.vue')
Vue.use(Router)

let _router = new Router({
	// mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
			path: '/businessGrade',
			name: 'businessGrade',
			component: businessGrade,
			meta: {
				searchOrder: true,
			}
		},
		{
			path: '/servicePlan',
			name: 'servicePlan',
			component: servicePlan,
			meta: {
				searchOrder: true,
				background: '#ffffff'
			}
		},

		{
			path: '/blank',
			name: 'Blank',
			component: Blank,
			meta: {
				searchOrder: false,
				background: '#f5f6fa'
			}
		},
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {
				searchOrder: false,
				background: '#ffffff',
				noHeader:true
			}
		},
		{
			path: '/registerSuccess',
			name: 'RegisterSuccess',
			component: RegisterSuccess,
			meta: {
				searchOrder: false,
				background: '#ffffff'
			}
		},
		{
			path: '/confirm',
			name: 'confirm',
			component: confirm,
		},
		{
			path: '/result/:status',
			name: 'result',
			component: Result,
			meta: {
				searchOrder: true
			}
		},
		{
			path: '/search',
			name: 'search',
			component: Search
		},
		{
			path: '/informationRegister',
			name: 'informationRegister',
			component: InformationRegister
		},
		{ //umall服務計劃列表
			path: '/servicePlanUmall',
			name: 'umallServicePlan',
			component: umallServicePlan,
			meta: {
				//      searchOrder: true,
				background: '#f5f6fa',
				noHeader:true,
				title:'服務計劃列表'
			}
		},
		{ //umall服務計劃詳情
			path: '/businessGradeUmall',
			name: 'umallBusinessGrade',
			component: umallBusinessGrade,
			meta: {
				//      searchOrder: true,
//				background: '#f5f6fa',
				noHeader:true,
				title:'服務計劃詳情'
			}
		},
		{ //umall基礎信息頁面
			path: '/informationRegisterUmall',
			name: 'UmallInformationRegister',
			component: UmallInformationRegister,
			meta:{
//				background: '#f5f6fa',
				noHeader:true,
				title:'完善資料'
			}
		},
		{ //Umall確認信息頁面
			path: '/confirmUmall',
			name: 'UmallConfirm',
			component: UmallConfirm,
			meta:{
//				background: '#f5f6fa',
				noHeader:true,
				title:'確認信息'
			}
		},
		{ //umall 宽频1+N基礎信息頁面
			path: '/informationRegisterUmallBroadband',
			name: 'UmallBroadbandInformationRegister',
			component: UmallBroadbandInformationRegister,
			meta:{
				noHeader:true,
				title:'完善資料'
			}
		},
		{ //umall 宽频1+N確認信息頁面
			path: '/confirmUmallBroadband',
			name: 'UmallBroadbandConfirm',
			component: UmallBroadbandConfirm,
			meta:{
				noHeader:true,
				title:'確認信息'
			}
		},
		{ //umall結果頁面
			path: '/resultUmallBroadband/:status',
			name: 'UmallBroadbandResult',
			component: UmallBroadbandResult,
			meta: {
			      noHeader:true,
			      title:'支付結果'
			    }
		},
		{ //umall結果頁面
			path: '/resultUmall/:status',
			name: 'UmallResult',
			component: UmallResult,
			meta: {
			      noHeader:true,
			      title:'支付結果'
			    }
		},
		{ //umall老的二维码支付頁面
			path: '/oldQrCode',
			name: 'OldQrCodePay',
			component: OldQrCodePay,
			meta: {
			      noHeader:true,
			      title:'二維碼支付'
			    }
		},
		{ //umall老的二维码支付頁面
			path: '/paying',
			name: 'OldQrCodePaying',
			component: OldQrCodePaying,
			meta: {
			      noHeader:true,
			      title:'二維碼支付'
			    }
		},
		{ //umall新的二维码支付頁面
			path: '/newQrCode',
			name: 'NewQrCodePay',
			component: NewQrCodePay   ,
				meta: {
					noHeader:true,
					title:'二維碼支付'
					}
		},
		{
			path: '/',
			redirect: '/servicePlan'
		},
		{
			path: '*',
			redirect: '/businessGrade'
		}
	]
})

_router.beforeEach((to, from, next) => {
	if(to.query.orgId || to.query.shopId || to.query.userId || to.query.appId) return next()
	if(from.query.orgId || from.query.shopId || from.query.userId || from.query.appId) {
		let _query = JSON.parse(JSON.stringify(to.query))
		if(from.query.orgId) _query.orgId = from.query.orgId
		if(from.query.shopId) _query.shopId = from.query.shopId
		if(from.query.userId) _query.userId = from.query.userId
		if(from.query.appId) _query.appId = from.query.appId
		next({
			name: to.name,
			params: to.params,
			query: _query
		})
	} else next()
})

export default _router